import { createAppSelector } from 'store/hooks';

export const routeManagerSelector = createAppSelector(
  [
    (state) => state.user.isUserLoggingOut,
    (state) => state.setting.error.message,
    (state) => state.setting.isFetchingDeviceSettings
  ],
  (isUserLoggingOut, errorMessage, isFetchingDeviceSettings) => {
    return {
      isUserLoggingOut,
      errorMessage,
      isFetchingDeviceSettings
    };
  }
);

export const embeddedPageLayoutSelector = createAppSelector(
  [
    (state) => state.setting.language,
    (state) => state.setting.platform,
    (state) => state.setting.font,
    (state) => state.modal.confirmAction.showConfirmModal,
    (state) => state.setting.isTokenAddedToInterceptor
  ],
  (language, platform, font, showConfirmModal, isTokenAddedToInterceptor) => {
    return {
      language,
      platform,
      font,
      showConfirmModal,
      isTokenAddedToInterceptor
    };
  }
);

export const protectedRoutesWrapperSelector = createAppSelector(
  [
    (state) => state.user.details,
    (state) => state.user.auth0User,
    (state) => state.setting.isShowPrivacyPolicyModal,
    (state) => state.setting.language,
    (state) => state.setting.isFetchingDeviceSettings
  ],
  (
    userDetails,
    auth0User,
    isShowPrivacyPolicyModal,
    language,
    isFetchingDeviceSettings
  ) => {
    return {
      userDetails,
      auth0User,
      isShowPrivacyPolicyModal,
      language,
      isFetchingDeviceSettings
    };
  }
);
